import { useEffect } from "react";

const IDENTITIES = {
  backoffice: {
    manifest: "/backoffice-manifest.webmanifest",
    serviceWorker: "/backoffice-sw.js",
    scope: "/backoffice",
    title: "Second Life Back Office",
    theme: "#0f2a3f",
    icon: "/owlico-owl.png",
  },
  tech: {
    manifest: "/tech-manifest.webmanifest",
    serviceWorker: "/tech-sw.js",
    scope: "/tech",
    title: "OWLICO Tech",
    theme: "#0b3d91",
    icon: "/tech-icon-192.png",
  },
  wiring: {
    manifest: "/wiring-manifest.webmanifest",
    serviceWorker: "/wiring-sw.js",
    scope: "/wiring",
    title: "OWLICO Wiring",
    theme: "#12343b",
    icon: "/wiring-icon-192.png",
  },
  capture: {
    manifest: "/capture-manifest.webmanifest",
    serviceWorker: "/capture-sw.js",
    scope: "/capture",
    title: "Second Life Mobile",
    theme: "#0b2e22",
    icon: "/capture-icon.jpg",
  },
  scanner: {
    manifest: "/scanner-manifest.webmanifest",
    serviceWorker: "/scanner-sw.js",
    scope: "/scanner",
    title: "Second Life Scanner",
    theme: "#163b2d",
    icon: "/scanner-icon-192.png",
  },
  store: {
    manifest: "/store-manifest.webmanifest",
    serviceWorker: "/store-sw.js",
    scope: "/",
    title: "Second Life Store",
    theme: "#0f2a3f",
    icon: "/store-icon.jpg",
  },
};

export function usePwaIdentity(name) {
  useEffect(() => {
    const identity = IDENTITIES[name];
    const isPublicStore = [
      "secondlifeappliances.com",
      "www.secondlifeappliances.com",
    ].includes(window.location.hostname);
    if (!identity || (name === "store" && !isPublicStore)) {
      return undefined;
    }
    if (document.querySelector('[data-testid="store-not-found"]')) {
      return undefined;
    }

    const previousTitle = document.title;
    const theme = document.querySelector('meta[name="theme-color"]');
    const previousTheme = theme?.content;
    const touchIcon = document.querySelector("link[data-pwa-touch-icon]");
    const previousTouchIcon = touchIcon?.href;
    let manifest = document.querySelector("link[data-pwa-identity]");

    if (!manifest) {
      manifest = document.createElement("link");
      manifest.rel = "manifest";
      manifest.dataset.pwaIdentity = name;
      document.head.appendChild(manifest);
    }

    manifest.href = identity.manifest;
    manifest.dataset.pwaIdentity = name;
    document.title = identity.title;

    let appTouchIcon = touchIcon;
    if (!appTouchIcon) {
      appTouchIcon = document.createElement("link");
      appTouchIcon.rel = "apple-touch-icon";
      appTouchIcon.dataset.pwaTouchIcon = name;
      document.head.appendChild(appTouchIcon);
    }
    appTouchIcon.href = identity.icon;

    if (theme) {
      theme.content = identity.theme;
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register(identity.serviceWorker, { scope: identity.scope })
        .catch(() => {});
    }

    return () => {
      if (manifest.dataset.pwaIdentity === name) {
        manifest.remove();
      }
      if (appTouchIcon.dataset.pwaTouchIcon === name) {
        if (previousTouchIcon) {
          appTouchIcon.href = previousTouchIcon;
        } else {
          appTouchIcon.remove();
        }
      }

      document.title = previousTitle;

      if (theme && previousTheme) {
        theme.content = previousTheme;
      }
    };
  }, [name]);
}
